import { render, staticRenderFns } from "./WithdrawApproveModal.vue?vue&type=template&id=155867a0&scoped=true&"
import script from "./WithdrawApproveModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawApproveModal.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawApproveModal.vue?vue&type=style&index=0&id=155867a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155867a0",
  null
  
)

export default component.exports